import { QueryClient } from '@tanstack/react-query';
import { LoaderFunctionArgs } from 'react-router';
import { listNotesQuery } from '~/pages/SystemNotes/api/systemNotes.queries';
import { NotesListModel } from '~/pages/SystemNotes/models/NotesListModel';
import { listSystemUsersQuery } from '~/shared/api/systemUsers.queries';
import { SystemUsersModel } from '~/shared/models/users/SystemUsersModel';
import { getSystemQuery } from '~/shared/api/system.queries';
import { requireUserRoleForSystemId } from '~/shared/auth/auth-utils';
import { assertIsDefined } from '~/types/assert-type';
import { SystemModel } from '~/shared/models/system/SystemModel';

export type SystemNotesLoaderData = {
  systemNotes: NotesListModel;
  systemUsers: SystemUsersModel;
};

export const systemNotesLoader =
  (queryClient: QueryClient) =>
  async ({
    params,
    request,
  }: LoaderFunctionArgs): Promise<SystemNotesLoaderData | Response> => {
    const { systemId } = params;

    assertIsDefined(systemId);

    await requireUserRoleForSystemId(
      queryClient,
      request,
      ['internal_admin', 'internal_engineer', 'admin', 'installer'],
      systemId,
    );

    assertIsDefined(systemId);

    const system = await queryClient.ensureQueryData(getSystemQuery(systemId));

    const systemModel = new SystemModel({ system });

    const [systemNotes, systemUsers] = await Promise.all([
      queryClient.ensureQueryData(listNotesQuery(systemModel)),
      queryClient.ensureQueryData(listSystemUsersQuery(system.name)),
    ]);

    return { systemNotes, systemUsers };
  };
